<form [formGroup]="form">
  @if (!!list) {
    @if (list?.weeks?.length > 0) {
      <table class="table table whitebox-inner">
        <thead>
          <tr>
            <th [colSpan]="6 + fieldList.length"></th>
            <th class="align-right">
              <i class="fa fa-arrow-circle-left fa-2x ev-blue-color"
                ngbTooltip="Woche früher"
                (click)="weekScrollPage(-1)">
              </i>
            </th>
            @for (index of weekPaginator.visibleWeekIndices; track index) {
              <th colspan="2"
                [ngClass]="{'frame-week': (list.weeks[index].first_day_of_week|date:'dd.MM.yyyy') === ($safeNavigationMigration(selectionData.week_start?.first_day_of_week)|date:'dd.MM.yyyy')}"
                >
                <div [ngbTooltip]="'Ab ' + (list.weeks[index].first_day_of_week|date:'dd.MM.yyyy') + (((list.weeks[index].first_day_of_week|date:'dd.MM.yyyy') === ($safeNavigationMigration(selectionData.week_start?.first_day_of_week)|date:'dd.MM.yyyy')) ? ' Material wird in dieser Woche benötigt' : '')">
                  <strong>
                    KW&nbsp;{{ list.weeks[index].week }}/{{ list.weeks[index].first_day_of_week|date:'yy' }}
                  </strong>
                  <div style="display:block; font-size:10px;">
                    {{ list.weeks[index].first_day_of_week|date:'dd.MM.yyyy' }}
                  </div>
                </div>
              </th>
            }
            <th>
              <i class="fa fa-arrow-circle-right fa-2x ev-blue-color"
                ngbTooltip="Woche später"
                (click)="weekScrollPage(1)">
              </i>
            </th>
          </tr>
          <tr>
            <th>
              <a (click)="sort('supplier')">
                Lieferant
              </a>
            </th>
            <th>
              <a (click)="sort('article_name')">
                Bezeichnung
              </a>
            </th>
            @for (field of fieldList; track field) {
              <th>{{field.name}}</th>
            }
            <th class="align-right">Lagerbestand</th>
            <th class="align-right">Bestellt</th>
            <th class="align-right">Bestätigt</th>
            <th class="align-right"><span ngbTooltip="Überfällig">Überf.</span></th>
            <th class="align-right">Planung</th>
            @for (index of weekPaginator.visibleWeekIndices; track index) {
              <th class="align-right">
                <i class="fa fa-truck"
                  [ngbTooltip]="'bestätigte Lieferungen in KW ' + list.weeks[index].week">
                </i>
              </th>
              <th class="align-right">
                <i class="fa fa-handshake-o"
                  [ngbTooltip]="'geplante Materialnutzung in KW ' + list.weeks[index].week">
                </i>
              </th>
            }
            <th></th>
          </tr>
          <tr class="filterrow">
            <th>
              <material-supplier-select-search formControlName="supplier_id"
                [groupId]="currentGroupId"
                [ngClass]="{ 'red_alert': !!filterFormErrors.supplier_id }">
              </material-supplier-select-search>
            </th>
            <th>
              @if (articleNames.data$ | async; as articles) {
                <select class="form-control input-sm"
                  name="article_name"
                  formControlName="article_name"
                  [ngClass]="{ 'red_alert': !!filterFormErrors.article_name }">
                  <option [ngValue]="null">-</option>
                  @for (article of articles; track article) {
                    <option [ngValue]="article">{{article}}</option>
                  }
                </select>
              } @else {
                <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
              }
              <loading-or-error #loadingOrError
                [loadingWrapper]="articleNames"
                [errorMessage]="'Konnte Artikelnamen nicht laden'">
              </loading-or-error>
            </th>
            @for (field of fieldList; track field) {
              <th>
                @switch (field.data_type) {
                  @case ('Auswahl') {
                    <select class="form-control input-sm"
                      [name]="field.html_name"
                      [ngClass]="{ 'red_alert': !!filterFormErrors[field.html_name] }"
                      [formControlName]="field.html_name">
                      <option [ngValue]="null" selected>-</option>
                      @if (!!missingChoices[field.html_name]) {
                        <option [ngValue]="missingChoices[field.html_name]"
                          >
                          {{missingChoices[field.html_name]}}
                        </option>
                      }
                      @for (choice of field.choices; track choice) {
                        <option [ngValue]="choice">{{choice}}</option>
                      }
                    </select>
                  }
                  @case ('Option') {
                    @switch (this.form[field.html_name]) {
                      @case (true) {
                        <i class="fa fa-check click" (click)="triStateChange(field)"></i>
                      }
                      @case ('true') {
                        <i class="fa fa-check click" (click)="triStateChange(field)"></i>
                      }
                      @case (false) {
                        <i class="fa fa-times click" (click)="triStateChange(field)"></i>
                      }
                      @case ('false') {
                        <i class="fa fa-times click" (click)="triStateChange(field)"></i>
                      }
                      @default {
                        <i class="fa fa-check click gray_font" (click)="triStateChange(field)"></i>
                      }
                    }
                  }
                  @default {
                    <input class="form-control input-sm"
                      [name]="field.html_name"
                      [ngClass]="{ 'red_alert': !!filterFormErrors[field.html_name] }"
                      [formControlName]="field.html_name">
                  }
                }
              </th>
            }
            <th [colSpan]="6 + weekPaginator.visibleWeekIndices.length * 2"></th>
          </tr>
        </thead>
        <tbody>
          @for (material of list.objects; track material; let index = $index) {
            <tr [business-order-material-unlimited-list-row]="material"
              [business-order-material-unlimited-list-row-selection-data]="selectionData"
              [business-order-material-unlimited-list-row-marked-week]="selectedWeek"
              [business-order-material-unlimited-list-row-marked-variation-id]="selectedVariationId"
              [business-order-material-unlimited-list-row-week-pages]="weekPaginator.visibleWeekIndices"
              [business-order-material-unlimited-list-row-weeks]="list.weeks"
              [business-order-material-unlimited-list-row-fields]="fieldList"
              [business-order-material-unlimited-list-row-lock-selection]="lockSelection"
              (business-order-material-unlimited-list-row-select)="emitSelect.emit($event)"
              (business-order-material-unlimited-list-row-mark-week)="setSelectedWeek($event, material.inventory.id)"
              >
            </tr>
          }
        </tbody>
      </table>
    }
    @if (list.count === 0) {
      <div>
        Keine Material Artikel mit diesen Kriterien Gefunden
      </div>
    }
    <ev-navigation [page]="list.page" [pages]="list.pages" [query]="form.value" (goto)="goto($event)"></ev-navigation>
  }
  @if (!list) {
    Liste wird geladen
  }


</form>
